import { render } from "./PromotionIndex.vue?vue&type=template&id=dc4c348c&scoped=true"
import script from "./PromotionIndex.vue?vue&type=script&lang=js"
export * from "./PromotionIndex.vue?vue&type=script&lang=js"

import "./PromotionIndex.vue?vue&type=style&index=0&id=dc4c348c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4c348c"]])

export default __exports__